import React from 'react'

import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';


function ibupdate() {
  const tabs = [
    { title: 'IB Updates', content: () => <div>
    
      <div className='cam-lower-sec '>
      <h1 className='title'style={{ paddingTop: '30px' }} >IB Updates 2025</h1>
      </div>
     <div className='ibdp-updates-sec'>
  
  
      <div className='ibdp-update-btn-sec'>

         <Link to="../pdf/Ib-update/EE_Guide_1st_assessment_2027.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
                 {/* Extended Essay Complete Sutdent Guide First Assessment 2027 */}
                 Extended essay guide First assessment 2027
                  </Link>

         <Link to="../pdf/Ib-update/ib-march-2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
                 Diploma Programme Updates 2025
                  </Link>
         <Link to="../pdf/Ib-update/Diploma Programme Assessment procedures 2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
                 Diploma Programme Assessment procedures 2025
                  </Link>
         <Link to="../pdf/Ib-update/Diploma Programme language A literature and language and literature.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
                 Diploma Programme language A: literature and language and literature 2025
                  </Link>
         <Link to="../pdf/Ib-update/DP Psychology Syllabus Changes.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
              DP Psychology Syllabus Changes
                  </Link>
        
         <Link to="../pdf/Ib-update/extended-essay-guide-first assessment 2027.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
             Extended Essay Guide First Assessment 2027
                  </Link>
         <Link to="../pdf/Ib-update/DPCP Digital Examinations.mp4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
             DPCP Digital Examinations - Video Update April 2025
                  </Link>
       
         <Link to="../pdf/Ib-update/IB Digital Exams.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
             IB Digital Exams
                  </Link>
         <Link to="../pdf/Ib-update/adverse-circumstances.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
     Adverse Circumstances Policy

                  </Link>
    
         <Link to="../pdf/Ib-update/conduct-of-examinations-booklet-2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
 Conduct of Examinations Booklet 2025
                  </Link>
      
      
         <Link to="../pdf/Ib-update/OPH_SpringGraduation_FINAL.mp4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
                  OPH Spring Graduation 

                  </Link>
      
      
         <Link to="https://mailbuild.ibo.org/t/r-e-thvdijy-l-q/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
                  Updates for May 2025 DPCP Examination Session

                  </Link>
         <Link to="https://pds.ibo.org/ai-in-the-classroom-for-dp-educators/#/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
AI In Ihe Classroom for DP Educators
                  </Link>
         <Link to="../pdf/Ib-update/ee_subjectbrief_en.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
International Baccalaureate
Diploma Programme Subject Brief
Extended Essay
First Assessment 2027
                  </Link>
         <Link to="../pdf/Ib-update/may-2026-examination-schedule.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
May 2026 Examination Schedule Final Version
                  </Link>

         <Link to="https://www.ibo.org/programmes/diploma-programme/assessment-and-exams/exam-schedule/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
DP and CP Exam Schedule
                  </Link>

         <Link to="../pdf/Ib-update/Primary Years Programme.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
PYP Theme Descriptors
                  </Link>

         <Link to="../pdf/Ib-update/IB Exchange What's New May.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
IB Exchange What's New May 2025
                  </Link>
         <Link to="../pdf/Ib-update/pyp-subjects.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
PYP subjects
                  </Link>
      
         <Link to="../pdf/Ib-update/pyp_additional_languages_pathway_en.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
 Additional Language(s) Learner Pathway
                  </Link>
         <Link to="https://vimeo.com/1065932162/2256869d15?share=copy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
Inquiry Learning Progressions: Insights from IB Educators
                  </Link>
         <Link to="../pdf/Ib-update/DP Environmental systems and 
societies.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
DP Environmental Systems and 
Societies 
                  </Link>
         <Link to="../pdf/Ib-update/Diploma Programme computer science.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
 Diploma Programme Computer Science
                  </Link>

         <Link to="../pdf/Ib-update/Diploma Programme extended essay.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
 Diploma Programme Extended Essay
                  </Link>
      
         <Link to="../pdf/Ib-update/dp_visual_arts_curriculum_review__second_update_to_teachers_(2022) (720p).mp4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className='ibdp-update-btn'
                  > 
 Dp Visual Arts Curriculum Review Second Update to Teachers (2022) 
                  </Link>



 
        
      </div>
     </div>
  
  
  
      </div> },

     
   
  ]


  return (
    <div>
      <div className='ibdpudate-sec'>
          <HorizontalTabs tabs={tabs} />
      </div>
 

    </div>
  )
}

export default ibupdate
